export const VALIDATION_TEMPLATE = {
  required: (field: string) => `${field}を入力してください`,
  pattern: (field: string) => `${field}の形式が正しくありません`,
  isHalfWidth: (field: string) => `${field}は半角で入力してください`,
  dairen: (field: string) => `${field}の先頭にDを入力してください`,
  lengthCheck: (field: string) => `${field}以上入力してください`,
  manhoursCheck: () => '工数A～Eのうち1つを選択してください',
  isPositiveInteger: () => '正の整数で入力してください',
  projectNumber: () =>
    'プロジェクトナンバーは半角英数字1〜8文字で入力してください',
  maxLength: (field: string, maxLength: number) =>
    `${field}は${maxLength}文字以内で入力してください`,
  rate: () => 'レートは小数点以下2桁までの半角数字で入力してください',
  startsWithDIfDairen: () => '社員コードの先頭にDを入力してください',
  password: () => 'パスワードは半角英数字8文字以上で入力してください',
  startBeforeEnd: () => '始業時間は終業時間より前の時間を入力してください',
};
